module.exports = __webpack_public_path__ + "img/LTS_CINB.55467f37.gif";